import React from 'react';

import 'bulma/css/bulma.min.css';
import WeatherApp from './WeatherApp';

function App() {
  return <WeatherApp />;
}

export default App;
